module.exports = __webpack_public_path__ + "img/cricketbazzi.58cbdd3b.jpg";